"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = {
    dataDimension: true
};
module.exports = exports["default"];
//# sourceMappingURL=category.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/model/config/model-defaults/category.js
// module id = 86
// module chunks = 0